import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/nodes/FormNodeContent/FormNodeContent.tsx";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { IconButton, TextField } from '@mui/material';
import { Cancel, CheckCircle } from '@mui/icons-material';
import React, { useRef, useState } from 'react';
import { Folder } from '@gmini/ui-kit';
import { NodeCheckbox } from "../../NodeCheckbox";
import { NodeExpand } from "../../../NodeExpand";
import { NodeLayout } from "../../NodeLayout";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FormNodeContent = function FormNodeContent(_ref) {
  var deepness = _ref.deepness,
      initialValue = _ref.initialValue,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      icon = _ref.icon;

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var inputRef = useRef(null);

  var submitHandler = function submitHandler(e) {
    e.preventDefault();
    submit(); // TODO
  };

  var submit = function submit() {
    onSubmit(value);
  };

  var changeHandler = function changeHandler(e) {
    setValue(e.target.value);
  }; // https://github.com/mui-org/material-ui/issues/7247
  // Баг с автофокусом


  React.useEffect(function () {
    var el = inputRef.current;

    if (el) {
      el.focus();
    }
  }, []);
  return /*#__PURE__*/_jsx(NodeLayout, {
    deepness: deepness,
    checkbox: /*#__PURE__*/_jsx(NodeCheckbox, {
      checked: false,
      disabled: true,
      onChange: function onChange() {// TODO remove
      }
    }),
    expandJsx: /*#__PURE__*/_jsx(NodeExpand, {
      hidden: true,
      expanded: false
    }),
    icon: icon ? icon : /*#__PURE__*/_jsx(Folder, {}),
    text: /*#__PURE__*/_jsx("form", {
      onSubmit: submitHandler,
      style: {
        width: '100%'
      },
      children: /*#__PURE__*/_jsx(TextField, {
        "data-test-id": "inputField",
        type: "text",
        size: "small",
        fullWidth: true,
        inputProps: {
          maxLength: 50,
          style: {
            fontSize: 14,
            paddingBottom: '2px'
          }
        },
        inputRef: inputRef,
        value: value,
        onChange: changeHandler,
        variant: "standard"
      })
    }),
    endContent: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(IconButton, {
        size: "small",
        "data-test-id": "submitName",
        edge: "end",
        onClick: submit,
        disabled: value.trim().length === 0,
        style: {
          padding: '3px',
          fontSize: '1.125rem'
        },
        children: /*#__PURE__*/_jsx(CheckCircle, {})
      }), /*#__PURE__*/_jsx(IconButton, {
        size: "small",
        "data-test-id": "cancel",
        edge: "end",
        onClick: onCancel,
        style: {
          padding: '3px',
          fontSize: '1.125rem'
        },
        children: /*#__PURE__*/_jsx(Cancel, {})
      })]
    })
  });
};